<template>
  <div v-if="lastPage > 1" class="flex justify-center mt-6 gap-2">
    <button 
      :disabled="currentPage === 1" 
      @click="$emit('page-changed', currentPage - 1)" 
      class="px-3 py-1 rounded border text-sm font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:hover:bg-white dark:disabled:hover:bg-gray-800"
    >
      Anterior
    </button>
    
    <template v-for="page in pageNumbers" :key="page">
      <span 
        v-if="page === '...'" 
        class="px-3 py-1 text-gray-400 dark:text-gray-500 cursor-default"
      >
        ...
      </span>
      <button 
        v-else 
        @click="$emit('page-changed', page)" 
        :class="[
          'px-3 py-1 rounded border text-sm font-semibold transition',
          page === currentPage 
            ? 'bg-blue-500 text-white border-blue-500' 
            : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
        ]"
      >
        {{ page }}
      </button>
    </template>
    
    <button 
      :disabled="currentPage === lastPage" 
      @click="$emit('page-changed', currentPage + 1)" 
      class="px-3 py-1 rounded border text-sm font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:hover:bg-white dark:disabled:hover:bg-gray-800"
    >
      Siguiente
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  lastPage: {
    type: Number,
    required: true
  },
  maxVisible: {
    type: Number,
    default: 7
  }
})

defineEmits(['page-changed'])

const pageNumbers = computed(() => {
  const { currentPage, lastPage, maxVisible } = props
  
  if (lastPage <= maxVisible) {
    return Array.from({ length: lastPage }, (_, i) => i + 1)
  }
  
  const pages = []
  const sidePages = Math.floor((maxVisible - 3) / 2)
  
  pages.push(1)
  
  let start = Math.max(2, currentPage - sidePages)
  let end = Math.min(lastPage - 1, currentPage + sidePages)
  
  if (currentPage - sidePages <= 2) {
    end = Math.min(lastPage - 1, maxVisible - 2)
  }
  
  if (currentPage + sidePages >= lastPage - 1) {
    start = Math.max(2, lastPage - maxVisible + 2)
  }
  
  if (start > 2) {
    pages.push('...')
  }
  
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }
  
  if (end < lastPage - 1) {
    pages.push('...')
  }
  
  if (lastPage > 1) {
    pages.push(lastPage)
  }
  
  return pages
})
</script>